import React from "react";
import LoadingSection from "../components/Sections/Loading";

const LoadingPage = () => {
  return (
    <div className="h-screen">
      <LoadingSection />
    </div>
  );
};

export default LoadingPage;
